import { Base64 } from "js-base64";
import Compressor from "compressorjs";
import api from "@/api";

const md5 = require("js-md5");

export default function uploadImage() {
  const afterRead = (file) => {
    return new Promise((resolve, reject) => {
      if (Array.isArray(file)) {
        Promise.all(file.map(dealFile)).then(resolve).catch(reject);
      } else {
        dealFile(file).then(resolve).catch(reject);
      }
    });
  };

  const dealFile = (file) => {
    return new Promise((resolve, reject) => {
      file.status = "uploading";
      file.message = "上传中...";
      imgPreview(file).then(resolve).catch(reject);
    });
  };

  // 将 base64 转换为文件
  const dataURLtoFile = (dataurl, name, type) => {
    const [header, base64] = dataurl.split(",");
    const binary = atob(base64);
    const array = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      array[i] = binary.charCodeAt(i);
    }
    console.log("header", header);
    return new File([array], name, { type });
  };

  const imgPreview = async (originFile) => {
    return new Promise((resolve, reject) => {
      const file = originFile.file;
      if (!file || !window.FileReader)
        return reject(new Error("FileReader not supported"));

      if (/^image/.test(file.type)) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = async function () {
          const result = this.result;
          const img = new Image();
          img.src = result;

          if (result.length <= 500 * 1024) {
            try {
              const url = await postImg(
                result,
                file.name,
                file.type,
                originFile
              );
              resolve(url);
            } catch (error) {
              reject(error);
            }
          } else {
            img.onload = async () => {
              imageToBlob(img, "image/png", (blob) => {
                compressImage(blob, file, originFile)
                  .then(resolve)
                  .catch(reject);
              });
            };
          }
        };
      } else {
        reject(new Error("Not an image file"));
      }
    });
  };

  // 将图片转换为 Blob 对象
  const imageToBlob = (image, mimeType, callback) => {
    const canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(image, 0, 0);
    canvas.toBlob(callback, mimeType || "image/png");
  };

  // 压缩图片
  const compressImage = (imageFile, file, originFile) => {
    return new Promise((resolve, reject) => {
      new Compressor(imageFile, {
        quality: 1,
        maxWidth: 1920,
        maxHeight: 1080,
        minWidth: 320,
        minHeight: 240,
        success(result) {
          const reader = new FileReader();
          reader.onloadend = () => {
            postImg(reader.result, file.name, file.type, originFile)
              .then(resolve)
              .catch(reject);
          };
          reader.readAsDataURL(result);
        },
        error(err) {
          console.error(err);
          reject(err);
        }
      });
    });
  };

  const postImg = (base64, name, type, originFile = null) => {
    const filedata = dataURLtoFile(base64, name, type);
    const currentTime = new Date().getTime();
    const deadline = currentTime + 1000 * 30;
    const sign = md5(JSON.stringify({ deadline }));

    const data = Base64.encode(JSON.stringify({ deadline }));
    const uploadtoken = `${sign}:${data}`;

    const params = new FormData();
    params.append("img", filedata);
    params.append("uploadtoken", uploadtoken);

    const config = {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    };

    return new Promise((resolve, reject) => {
      api
        .upload(params, config)
        .then((res) => {
          if (res.code === 1) {
            if (originFile) {
              originFile.status = "successed";
              originFile.url = res.data;
              originFile.message = res.msg;
            }
            resolve(res);
          } else {
            handleUploadError(originFile, "上传失败", reject);
          }
        })
        .catch((err) => {
          handleUploadError(originFile, "网络错误，请重试", reject, err);
        });
    });
  };

  const handleUploadError = (originFile, message, reject, err = null) => {
    if (originFile) {
      originFile.status = "failed";
      originFile.message = message;
    }
    if (err) {
      console.error(err);
    }
    reject(new Error(message));
  };

  return {
    afterRead,
    postImg
  };
}
